"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportReply = exports.reportReview = exports.setReviewHelpful = exports.submitReview = exports.resetReviewsStatsFetch = exports.getReviewsStats = exports.resetReviewsFetch = exports.getAllReviews = exports.getReviews = void 0;

var ActionTypes = _interopRequireWildcard(require("./ActionTypes"));

var ecosystemClient = _interopRequireWildcard(require("../clients/ecosystemClient"));

var _I18n = _interopRequireDefault(require("I18n"));

var notificationsKey = 'appMarketplace.detail.reviews';

var getReviews = function getReviews(queries) {
  return function (dispatch) {
    dispatch({
      type: ActionTypes.REVIEWS_FETCH_REQUESTED
    });
    return ecosystemClient.fetchReviews(queries).then(function (resp) {
      dispatch({
        type: ActionTypes.REVIEWS_FETCH_RECEIVED,
        payload: resp
      });
    }).catch(function (err) {
      dispatch({
        type: ActionTypes.REVIEWS_FETCH_FAILED,
        payload: err
      });
    });
  };
};

exports.getReviews = getReviews;

var getAllReviews = function getAllReviews(offeringId) {
  return function (dispatch) {
    var reviewsOffset = 0;
    var totalReviewsList = [];
    dispatch({
      type: ActionTypes.REVIEWS_FETCH_REQUESTED
    });

    var recursivelyGetAllReviews = function recursivelyGetAllReviews() {
      return ecosystemClient.fetchReviews({
        offeringId: offeringId,
        offset: reviewsOffset
      }).then(function (resp) {
        var total = resp.total,
            reviews = resp.reviews;
        totalReviewsList = totalReviewsList.concat(reviews);

        if (totalReviewsList.length < total) {
          reviewsOffset = reviewsOffset + 10;
          return recursivelyGetAllReviews();
        } else {
          return dispatch({
            type: ActionTypes.REVIEWS_FETCH_RECEIVED,
            payload: {
              reviews: totalReviewsList,
              total: resp.total
            }
          });
        }
      }).catch(function (err) {
        dispatch({
          type: ActionTypes.REVIEWS_FETCH_FAILED,
          payload: err
        });
      });
    };

    return recursivelyGetAllReviews(offeringId);
  };
};

exports.getAllReviews = getAllReviews;

var resetReviewsFetch = function resetReviewsFetch() {
  return {
    type: ActionTypes.REVIEWS_FETCH_RESET
  };
};

exports.resetReviewsFetch = resetReviewsFetch;

var getReviewsStats = function getReviewsStats(offeringId) {
  return function (dispatch) {
    dispatch({
      type: ActionTypes.REVIEWS_STATS_REQUESTED
    });
    return ecosystemClient.fetchReviewsStats(offeringId).then(function (resp) {
      dispatch({
        type: ActionTypes.REVIEWS_STATS_RECEIVED,
        payload: resp
      });
    }).catch(function (err) {
      dispatch({
        type: ActionTypes.REVIEWS_STATS_FAILED,
        payload: err
      });
    });
  };
};

exports.getReviewsStats = getReviewsStats;

var resetReviewsStatsFetch = function resetReviewsStatsFetch() {
  return {
    type: ActionTypes.REVIEWS_STATS_RESET
  };
};

exports.resetReviewsStatsFetch = resetReviewsStatsFetch;

var submitReview = function submitReview(review) {
  return function (dispatch) {
    dispatch({
      type: ActionTypes.REVIEW_WRITE_REQUESTED
    });
    return ecosystemClient.writeReview(review).then(function (resp) {
      dispatch({
        type: ActionTypes.REVIEW_WRITE_RECEIVED,
        payload: resp,
        meta: {
          notification: {
            titleText: _I18n.default.text(notificationsKey + ".write.success.titleText")
          }
        }
      });
      return resp;
    }).catch(function (err) {
      dispatch({
        type: ActionTypes.REVIEW_WRITE_FAILED,
        payload: err,
        error: true,
        meta: {
          notification: {
            type: 'danger',
            titleText: _I18n.default.text(notificationsKey + ".write.error.titleText"),
            message: _I18n.default.text(notificationsKey + ".write.error.message")
          }
        }
      });
      throw err;
    });
  };
};

exports.submitReview = submitReview;

var setReviewHelpful = function setReviewHelpful(reviewId, userId, isHelpful) {
  return function (dispatch) {
    dispatch({
      type: ActionTypes.REVIEW_HELPFUL_REQUESTED
    });
    return ecosystemClient.toggleReviewHelpful(reviewId, isHelpful).then(function () {
      dispatch({
        type: ActionTypes.REVIEW_HELPFUL_RECEIVED,
        payload: {
          reviewId: reviewId,
          userId: userId,
          isHelpful: isHelpful
        }
      });
    }).catch(function (err) {
      dispatch({
        type: ActionTypes.REVIEW_HELPFUL_FAILED,
        payload: err,
        meta: {
          notification: {
            type: 'danger',
            titleText: _I18n.default.text(notificationsKey + ".helpful.error.titleText"),
            message: _I18n.default.text(notificationsKey + ".helpful.error.message")
          }
        }
      });
    });
  };
};

exports.setReviewHelpful = setReviewHelpful;

var reportReview = function reportReview(_ref) {
  var reviewId = _ref.reviewId,
      reason = _ref.reason,
      comment = _ref.comment;
  return function (dispatch) {
    dispatch({
      type: ActionTypes.REVIEW_REPORT_REQUESTED
    });
    return ecosystemClient.reportReview({
      reviewId: reviewId,
      reason: reason,
      comment: comment
    }).then(function (resp) {
      dispatch({
        type: ActionTypes.REVIEW_REPORT_RECEIVED,
        payload: resp,
        meta: {
          notification: {
            titleText: _I18n.default.text(notificationsKey + ".reportModal.success.titleText"),
            message: _I18n.default.text(notificationsKey + ".reportModal.success.message")
          }
        }
      });
    }).catch(function (err) {
      var alreadyReported = err.responseJSON && err.responseJSON.message && err.responseJSON.message.includes('already reported');
      var errorKey = alreadyReported ? 'duplicate_error' : 'error';
      dispatch({
        type: ActionTypes.REVIEW_REPORT_FAILED,
        payload: err,
        meta: {
          notification: {
            type: 'danger',
            titleText: _I18n.default.text(notificationsKey + ".reportModal." + errorKey + ".titleText"),
            message: _I18n.default.text(notificationsKey + ".reportModal." + errorKey + ".message")
          }
        }
      });
    });
  };
};

exports.reportReview = reportReview;

var reportReply = function reportReply(_ref2) {
  var reviewId = _ref2.reviewId,
      replyId = _ref2.replyId,
      reason = _ref2.reason,
      comment = _ref2.comment;
  return function (dispatch) {
    dispatch({
      type: ActionTypes.REVIEW_REPORT_REPLY_REQUESTED
    });
    return ecosystemClient.reportReply({
      reviewId: reviewId,
      replyId: replyId,
      reason: reason,
      comment: comment
    }).then(function (resp) {
      dispatch({
        type: ActionTypes.REVIEW_REPORT_REPLY_RECEIVED,
        payload: resp,
        meta: {
          notification: {
            titleText: _I18n.default.text(notificationsKey + ".reportModal.success.titleText"),
            message: _I18n.default.text(notificationsKey + ".reportModal.success.message")
          }
        }
      });
    }).catch(function (err) {
      var alreadyReported = err.responseJSON && err.responseJSON.message && err.responseJSON.message.includes('already reported');
      var errorKey = alreadyReported ? 'duplicate_error' : 'error';
      dispatch({
        type: ActionTypes.REVIEW_REPORT_REPLY_FAILED,
        payload: err,
        meta: {
          notification: {
            type: 'danger',
            titleText: _I18n.default.text(notificationsKey + ".reportModal." + errorKey + ".titleText"),
            message: _I18n.default.text(notificationsKey + ".reportModal." + errorKey + ".message")
          }
        }
      });
    });
  };
};

exports.reportReply = reportReply;


//////////////////
// WEBPACK FOOTER
// ./js/actions/ReviewsActions.js
// module id = 138
// module chunks = 209 210 211 212